"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboConfiguration = exports.getDefaultChartType = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var commonConfiguration_1 = require("../_chartCreators/commonConfiguration");
var lineConfiguration_1 = require("../lineChart/lineConfiguration");
var common_1 = require("../_util/common");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var variables_1 = require("../_chartCreators/styles/variables");
var COLUMN = sdk_ui_1.VisualizationTypes.COLUMN, LINE = sdk_ui_1.VisualizationTypes.LINE;
function getDefaultComboTypes(config) {
    var _a, _b;
    return {
        primaryChartType: (_a = config === null || config === void 0 ? void 0 : config.primaryChartType) !== null && _a !== void 0 ? _a : COLUMN,
        secondaryChartType: (_b = config === null || config === void 0 ? void 0 : config.secondaryChartType) !== null && _b !== void 0 ? _b : LINE,
    };
}
function getDefaultChartType(config) {
    var _a = getDefaultComboTypes(config), primaryChartType = _a.primaryChartType, secondaryChartType = _a.secondaryChartType;
    if (primaryChartType === secondaryChartType) {
        return primaryChartType;
    }
    if (primaryChartType === COLUMN || secondaryChartType === COLUMN) {
        return COLUMN;
    }
    return LINE;
}
exports.getDefaultChartType = getDefaultChartType;
function isOnlyLineSeries(config, definition) {
    var _a = getDefaultComboTypes(config), primaryChartType = _a.primaryChartType, secondaryChartType = _a.secondaryChartType;
    var buckets = definition ? definition.buckets : [];
    var primaryBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.MEASURES);
    var secondaryBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.SECONDARY_MEASURES);
    var isEmptyPrimaryMeasure = !primaryBucket || sdk_model_1.bucketIsEmpty(primaryBucket);
    var isEmptySecondaryMeasure = !secondaryBucket || sdk_model_1.bucketIsEmpty(secondaryBucket);
    var isLineChartOnLeftAxis = common_1.isLineChart(primaryChartType);
    var isLineChartOnRightAxis = common_1.isLineChart(secondaryChartType);
    return ((isLineChartOnLeftAxis && isLineChartOnRightAxis) ||
        (isLineChartOnLeftAxis && isEmptySecondaryMeasure) ||
        (isEmptyPrimaryMeasure && isLineChartOnRightAxis));
}
function getComboConfiguration(config, definition, theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var series = isOnlyLineSeries(config, definition)
        ? {
            series: {
                states: {
                    inactive: {
                        opacity: 1,
                    },
                },
                borderColor: "#00000000",
            },
        }
        : {
            series: {
                borderColor: "#00000000",
            },
        };
    return {
        chart: {
            type: getDefaultChartType(config),
            spacingTop: 20,
        },
        plotOptions: tslib_1.__assign({ column: {
                dataLabels: {
                    enabled: true,
                    crop: false,
                    overflow: "none",
                    padding: 2,
                },
                maxPointWidth: commonConfiguration_1.MAX_POINT_WIDTH,
                borderColor: "#00000000",
            }, line: {
                marker: {
                    symbol: "circle",
                    radius: 4.5,
                    lineColor: (_e = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.chart) === null || _a === void 0 ? void 0 : _a.backgroundColor) !== null && _b !== void 0 ? _b : (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.complementary) === null || _d === void 0 ? void 0 : _d.c0) !== null && _e !== void 0 ? _e : variables_1.styleVariables.gdColorBackground,
                },
                lineWidth: lineConfiguration_1.LINE_WIDTH,
                fillOpacity: 0.3,
                stickyTracking: false,
                states: {
                    hover: {
                        lineWidth: lineConfiguration_1.LINE_WIDTH + 1,
                    },
                },
                dataLabels: {
                    style: {
                        fontWeight: "normal",
                    },
                },
            }, area: {
                marker: {
                    symbol: "circle",
                    radius: 4.5,
                    lineColor: (_k = (_g = (_f = theme === null || theme === void 0 ? void 0 : theme.chart) === null || _f === void 0 ? void 0 : _f.backgroundColor) !== null && _g !== void 0 ? _g : (_j = (_h = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _h === void 0 ? void 0 : _h.complementary) === null || _j === void 0 ? void 0 : _j.c0) !== null && _k !== void 0 ? _k : variables_1.styleVariables.gdColorBackground,
                },
                lineWidth: lineConfiguration_1.LINE_WIDTH,
                fillOpacity: 0.6,
                stickyTracking: false,
                states: {
                    hover: {
                        lineWidth: lineConfiguration_1.LINE_WIDTH + 1,
                    },
                },
            } }, series),
    };
}
exports.getComboConfiguration = getComboConfiguration;
//# sourceMappingURL=comboConfiguration.js.map